import { all, fork, call, take, put, select } from "redux-saga/effects"

import { watchLoanApplicationFetch } from './sagas/loanApplication/fetch'
import { watchLoanApplicationUpdate } from './sagas/loanApplication/update'
import { watchLoanApplicationUserGoback } from './sagas/loanApplicationUser/goback'
import { watchLoanApplicationUserGoto } from './sagas/loanApplicationUser/goto'

import { watchLoanUpdateFinancials } from './sagas/loanApplicationUser/financials'
import { watchLoanUpdateIncome } from './sagas/loanApplicationUser/income'
import { watchLoanUpdateExpense } from './sagas/loanApplicationUser/expense'
import { watchLoanUpdateCommitments } from './sagas/loanApplicationUser/commitments'
import { watchLoanUpdateAssets } from './sagas/loanApplicationUser/assets'
import { watchLoanUpdateProfile } from './sagas/loanApplicationUser/profile'
import { watchLoanUpdateLoanDetail } from './sagas/loanApplicationUser/loanDetail'
import { watchLoanUpdateLoanSummary } from './sagas/loanApplicationUser/loanSummary'
import { watchLoanUpdateEmployments } from './sagas/loanApplicationUser/employments'
import { watchLoanUpdateDeclaration } from './sagas/loanApplicationUser/declaration'
import { watchLoanUpdateReview } from './sagas/loanApplicationUser/review'
import { watchReadyForFinal } from './sagas/loanApplicationUser/readyForFinal'
import { watchLoanSetupCalculator } from './sagas/loanApplicationUser/loanSetupCalculator'

export default function* loanApplicationSaga() {
  yield all([
    fork(watchLoanApplicationFetch),
    fork(watchLoanApplicationUpdate),
    fork(watchLoanApplicationUserGoback),
    fork(watchLoanApplicationUserGoto),
    fork(watchLoanUpdateFinancials),
    fork(watchLoanUpdateCommitments),
    fork(watchLoanUpdateAssets),
    fork(watchLoanUpdateIncome),
    fork(watchLoanUpdateExpense),
    fork(watchLoanUpdateProfile),
    fork(watchLoanUpdateLoanDetail),
    fork(watchLoanUpdateLoanSummary),
    fork(watchLoanUpdateEmployments),
    fork(watchLoanUpdateDeclaration),
    fork(watchLoanUpdateReview),
    fork(watchReadyForFinal),
    fork(watchLoanSetupCalculator),
  ])
};
